import React, { Component } from 'react';
import { Spin, Affix, Card, Switch, Button} from 'antd'
import {initializeGlobalViewer, protColor} from '../../actions/viewerActions';
import { fetchBulbData} from  '../../actions/httpActions'
import {connect} from 'react-redux';
import {pdbPdbFileUrl} from '../../UrlManager'
import './molviewer.css'

function checkFileExistence(url) {
    return new Promise((resolve) => {
        window.jQuery.ajax({
            type: 'HEAD',
            url: url,
            success: (data, textStatus, xhr) => {
                // Assuming a minimal realistic file size (e.g., 1KB for argument's sake)
                const MIN_FILE_SIZE = 2024; // Adjust based on your knowledge of expected file sizes
                const contentLength = parseInt(xhr.getResponseHeader('Content-Length'), 10);

                if (contentLength > MIN_FILE_SIZE) {
                    resolve(true); // File likely exists
                } else {
                    // File size too small, likely doesn't exist or is a placeholder
                    resolve(false);
                }
            },
            error: () => {
                resolve(false); // File does not exist or another error occurred
            },
        });
    });
}

class MolViewer extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, affixed: false, searchid:null };
    }

    takeScreenshot = () => {
        const { viewer } = this; // Assuming viewer is correctly initialized and available
        if (viewer) {
            // const width = 1920; // Desired screenshot width
            // const height = 1080; // Desired screenshot height
            // viewer.setViewSize(width, height); // Temporarily set high resolution
            const dataUrl = viewer.pngURI(); // Capture the screenshot as a data URL
    
            const link = document.createElement('a'); // Create a link
            link.download = `CASTpFold_${this.state.searchid}_Screenshot.png`; // Set the default filename for the download
            link.href = dataUrl; // Set the href to the data URL
            document.body.appendChild(link); // Add to the document
            link.click(); // Trigger the download
            document.body.removeChild(link); // Clean up
    
            // viewer.setViewSize(this.state.originalWidth, this.state.originalHeight); // Reset size
            viewer.render(); // Re-render the viewer
        } else {
            console.error('Viewer not initialized');
        }
    };
    

    transformSearchId = (id) => {
        if (id.length === 4) {
            return id.toLowerCase();
        } else if (id.length === 6 || id.length === 10) {
            return id.toUpperCase();
        } else if (id.length === 15) {
            return id.toLowerCase();
        }
        return id;
    }

    componentDidMount = () => {
        const transformedId = this.transformSearchId(this.props.searchid);
        this.createViewer();
        const viewerBox = document.getElementById(`viewer-box${transformedId}`);
        this.setState({
            loading: false,
            originalHeight: viewerBox.clientHeight,
            originalWidth: viewerBox.clientWidth,
            affixedHeight: viewerBox.clientHeight, 
            affixedWidth: viewerBox.clientWidth,   
            searchid: transformedId,
        }, () => {
            this.renderViewer();
        });
    }


    componentDidUpdate = () => {
        const transformedId = this.transformSearchId(this.props.searchid);
        if(this.state.searchid !== transformedId){
            this.setState({searchid: transformedId});
            this.renderViewer();
        }
    }

    changeAffixStatus = (affixed) => {
        let viewer = this.viewer;
        const { originalHeight, originalWidth, affixedHeight, affixedWidth } = this.state;

        if (viewer) {
            if (affixed) {
                viewer.setHeight(affixedHeight);
                viewer.setWidth(affixedWidth);
            } else {
                viewer.setHeight(originalHeight);
                viewer.setWidth(originalWidth);
            }
            viewer.render();
        }
    }
    

    render = () => (
        <div align='right'>
            <Affix offsetTop={40} onChange={this.changeAffixStatus} >
                <Spin spinning={this.state.loading} size="large">
                    <Card id={`viewer-box${this.transformSearchId(this.props.searchid)}`} className={this.state.affixed ? 'testaffixed' : 'test'}>
                    </Card>
                    {/* <Button size="small" type="primary" onClick={() => this.componentDidMount()} className="load-button">
                        Reload Viewer
                    </Button> */}
                    <Button type="primary" onClick={this.takeScreenshot} size="small" style={{ marginRight: '10px' }}>
                        Take Screenshot
                    </Button>
                    <Switch size="small" defaultChecked
                        checkedChildren="Spectrum" 
                        unCheckedChildren="Plain"
                        onChange={(spectrum)=>{protColor(spectrum)}}
                    />
                </Spin>
            </Affix>
        </div>
    )
    

    createViewer = ()=>{
        if(this.viewer){
            return;
        }
        const transformedId = this.transformSearchId(this.props.searchid);
        this.viewer = window.$3Dmol.createViewer(`viewer-box${transformedId}`, {})
        initializeGlobalViewer(this.viewer);
    }

    renderViewer = async () => {
        const transformedId = this.transformSearchId(this.props.searchid);
        this.viewer.clear();
      
        // Get both URLs
        const { pdbUrl, cifUrl } = pdbPdbFileUrl(transformedId);
      
        // Initiate both checks simultaneously
        const [pdbExists, cifExists] = await Promise.all([
            checkFileExistence(pdbUrl),
            checkFileExistence(cifUrl)
        ]);
      
        // Log the existence of PDB and CIF files
        // console.log(`PDB file exists: ${pdbExists}`, `CIF file exists: ${cifExists}`);
    
        // Decide which file to load based on existence
        if (pdbExists) {
            // console.log('Loading PDB file.');
            this.loadModel(pdbUrl, 'pdb');
        } else if (cifExists) {
            // console.log('Loading CIF file.');
            this.loadModel(cifUrl, 'cif');
        } else {
            console.error('Neither PDB nor CIF files could be found.');
        }
    };
    

      loadModel = (url, format) => {
        window.jQuery.ajax({
          url: url,
          success: (data) => {
            this.viewer.addModel(data, format);
            this.viewer.setStyle({}, {cartoon: {color: 'spectrum'}});
            this.viewer.zoomTo();
            this.viewer.zoom(1.2, 1000);
            this.viewer.render();
            // console.log(`${format.toUpperCase()} model loaded successfully.`);
          },
          error: () => {
            console.error(`Failed to load the ${format.toUpperCase()} model.`);
          },
        });
      };
}

const mapStateToProps = state => ({
    searchid: state.router.location.search.slice(1),
    //viewer: state.viewer.viewer,
});
export default connect(mapStateToProps)(MolViewer);


// WEBPACK FOOTER //
// ./src/components/searchpage/Molviewer.js